// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiUsersRepoService } from '@client/app/services/api/api-users-repo.service';
import { ApiUsersService } from '@client/app/pages/admin/api-users/services/api-users.service';
import { ApiUsersFormComponent } from '@client/app/pages/admin/api-users/forms/api-users-form.component';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { CopyDialogService } from '@client/app/services/copy-dialog/copy-dialog.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { proxyApiPath } from '@monsido/core/constants/general.constant';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'api-users-dashboard',
    templateUrl: './api-users-dashboard.component.html',
    styleUrls: [],
    standalone: false,
})
export class ApiUsersDashboardComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    loading = false;
    apiUsers: any[] = [];
    apiPath: string = '';
    accountId: any;

    // Properties required by BaseComponent and template
    promise: Promise<any> | null = null;

    constructor (
        protected apiUsersRepo: ApiUsersRepoService,
        private readonly apiUsersService: ApiUsersService,
        private readonly loadingService: MonLoadingService,
        public override sessionService: SessionService,
        private readonly monEventService: MonEventService,
        private readonly monModalService: MonModalService,
        private readonly translateService: TranslateService,
        private readonly copyDialogService: CopyDialogService,
        private readonly loginService: LoginService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.apiPath = proxyApiPath;
        this.accountId = this.sessionService.agreement?.account?.id;
        this.apiUsers = [];
        this.getPage = () => {
            void this.loadApiUsers();
        };
        this.loadApiUsers();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getScopeTranslation (scopeValue: any) {
        return this.apiUsersService.getScopeTranslation(scopeValue);
    }

    async loadApiUsers (): Promise<void> {
        this.loading = true;

        try {
            const params: any = {
                page: this.page,
                page_size: this.pageSize,
            };

            this.promise = this.apiUsersRepo.getAll(params).then((apiUsers: any) => {
                this.apiUsers = apiUsers;
                this.updateDropdowns();
            }, () => {});

        } finally {
            this.loading = false;
        }
    }

    updateDropdowns () {
        for (const apiUser of this.apiUsers) {
            const dropdown = [
                {
                    label: this.translateService.getString('See API Token'),
                    leftIcon: 'faCog',
                    action: ()=>this.copyApiKey(apiUser.token),
                },
                {
                    label: this.translateService.getString('Revoke token'),
                    leftIcon: 'faRedoAlt',
                    action: ()=>this.revokeToken(apiUser),
                },
                {
                    label: this.translateService.getString('Delete'),
                    leftIcon: 'faTrashAlt',
                    action: ()=>this.removeApiUser(apiUser),
                },
            ];

            apiUser.dropdown = dropdown;
        }
    }

    copyApiKey (apiKey: any) {
        this.copyDialogService.open(apiKey, this.translateService.getString('API Token'));
    }

    openDialog (apiUser?: any) {
        const params = {
            body: ApiUsersFormComponent,
            size: 'lg',
            data: {
                apiUser: apiUser,
            },
        };

        const callback = (apiUserUpdate: any) => {
            if (typeof apiUserUpdate === 'object') {
                this.loadApiUsers();
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    revokeToken (apiUser: any) {
        this.monModalService
            .confirm(
                this.translateService.getString(
                    'Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it\'s place',
                    {
                        strongBegin: '<strong>',
                        strongEnd: '</strong>',
                        newLine: '<br>',
                        apiUserId: apiUser.id,
                    },
                ),
            )
            .then(() => {
                this.loading = true;
                this.promise = this.apiUsersRepo.revokeToken(apiUser)
                    .then(() => {
                        this.loadApiUsers();
                    }, () => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }, () => {});
    }

    removeApiUser (apiUser: any) {
        this.monModalService
            .confirm(
                this.translateService.getString('Are you sure you want to delete the API User [[apiUserId]]', {
                    apiUserId: apiUser.id,
                }),
            )
            .then(() => {
                this.loading = true;
                this.promise = this.apiUsersRepo.destroy(apiUser)
                    .then(() => {
                        this.loadApiUsers();
                    }, () => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }, () => {});
    }

    trackByIndex (index: number): number {
        return index;
    }
}
